module.exports = __webpack_public_path__ + "img/54.610e87ce.jpg";